import React, { ReactNode } from 'react';

import Picture from 'components/Picture';
import { urlFor } from '@root/lib/sanity';
import { Picture as SanityPicture } from '@root/sanity/sanity.types';

type ColorOfTheYearProps = {
  title: string;
  image: SanityPicture;
  children?: ReactNode;
};

const ColorOfTheYear = ({ title, image, children }: ColorOfTheYearProps) => (
  <div className={'ColorOfTheYear container my-64 items-center'}>
    <div className="m-auto max-w-[276px] sm:flex sm:max-w-[700px] sm:flex-row">
      {image?.asset && (
        <Picture hero className="aspect-ratio-5by7" url={urlFor(image.asset).url()!} alt={image?.alt ?? ''} />
      )}

      <div className="bg-gray-lighter p-32 text-white">
        <div className="mt-16 block">
          <span className={'text-h2 mb-8 whitespace-pre-line bg-gold-dark decoration-clone px-4 leading-9 text-white'}>
            {title}
          </span>
        </div>

        <div className={'mt-8 font-display tracking-widest text-gray-darker'}>{children}</div>
      </div>
    </div>
  </div>
);

export default ColorOfTheYear;
